import React from 'react';
import { CTAButton } from './ui/CTAButton';
export function SolutionSection() {
  return <section className="py-24 px-4 bg-[#1a0a2e] text-white relative overflow-hidden" data-id="element-152">
      <div className="max-w-5xl mx-auto relative z-10" data-id="element-153">
        <div className="text-center mb-16 max-w-3xl mx-auto space-y-6" data-id="element-154">
          <h2 className="text-3xl md:text-5xl font-bold leading-tight mb-8" data-id="element-155">
            La Noche de Impacto no es un evento.
            <br data-id="element-156" />
            <span className="text-[#F5A623]" data-id="element-157">
              Es una experiencia que cambia lo que crees que puedes hacer.
            </span>
          </h2>

          <div className="text-lg md:text-xl text-gray-300 space-y-4" data-id="element-158">
            <p data-id="element-159">La mayoría de los entrenamientos te dan información.</p>
            <p data-id="element-160">
              Te explican por qué tienes miedos. Te dan herramientas. Te
              motivan.
            </p>
            <p data-id="element-161">Y tres días después... todo sigue igual.</p>
            <p className="font-bold text-white pt-4" data-id="element-162">¿Por qué?</p>
            <p className="text-[#F5A623] font-bold text-2xl" data-id="element-163">
              Porque la mente no cambia con información.
            </p>
            <p className="text-[#F5A623] font-bold text-2xl" data-id="element-164">
              La mente cambia con experiencia.
            </p>
            <p className="pt-4 font-medium text-white" data-id="element-165">
              En la Noche de Impacto vas a vivir algo que tu cerebro no va a
              poder ignorar.
            </p>
          </div>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-20" data-id="element-166">
          <div className="bg-white/5 border border-white/10 p-8 rounded-3xl backdrop-blur-sm hover:bg-white/10 transition-colors" data-id="element-167">
            <div className="text-4xl mb-4" data-id="element-168">🧠</div>
            <h3 className="text-xl font-bold text-[#F5A623] mb-4" data-id="element-169">
              PASO 1 — ENTIENDE
            </h3>
            <p className="text-gray-300 leading-relaxed" data-id="element-170">
              Vas a entender cómo funciona tu mente y exactamente por qué te ha
              limitado hasta hoy.
            </p>
          </div>

          <div className="bg-white/5 border border-white/10 p-8 rounded-3xl backdrop-blur-sm hover:bg-white/10 transition-colors" data-id="element-171">
            <div className="text-4xl mb-4" data-id="element-172">🎯</div>
            <h3 className="text-xl font-bold text-[#F5A623] mb-4" data-id="element-173">
              PASO 2 — IDENTIFICA
            </h3>
            <p className="text-gray-300 leading-relaxed" data-id="element-174">
              Vas a identificar con precisión cuál es el límite que más te ha
              frenado — y lo vas a escribir en una tabla.
            </p>
          </div>

          <div className="bg-white/5 border border-[#5B2D8E] p-8 rounded-3xl backdrop-blur-sm hover:bg-white/10 transition-colors relative overflow-hidden" data-id="element-175">
            <div className="absolute top-0 right-0 w-32 h-32 bg-[#5B2D8E] blur-[50px] opacity-50" data-id="element-176"></div>
            <div className="text-4xl mb-4 relative z-10" data-id="element-177">💥</div>
            <h3 className="text-xl font-bold text-[#F5A623] mb-4 relative z-10" data-id="element-178">
              PASO 3 — ROMPE
            </h3>
            <div className="relative z-10 mb-4 rounded-xl overflow-hidden" data-id="element-179">
              <img src="https://cdn.magicpatterns.com/uploads/47BVo4SC1ExeDZDSjroVjv/Rompe_tabla.jpg" alt="Puño rompiendo una tabla de madera" className="w-full h-auto object-cover" data-id="element-180" />
            </div>
            <p className="text-gray-300 leading-relaxed relative z-10" data-id="element-181">
              Con toda una comunidad apoyándote, vas a romper esa tabla con tus
              propias manos. Físicamente. Para siempre.
            </p>
          </div>
        </div>

        {/* Explanation */}
        <div className="max-w-3xl mx-auto text-center space-y-6 bg-gradient-to-b from-transparent to-[#5B2D8E]/20 p-8 md:p-12 rounded-3xl border border-white/5" data-id="element-182">
          <h3 className="text-3xl font-bold mb-8" data-id="element-183">
            ¿Por qué romper una tabla?
          </h3>

          <div className="mb-8 rounded-2xl overflow-hidden shadow-lg" data-id="element-184">
            <img src="https://cdn.magicpatterns.com/uploads/xAMU2eZdToN3cHykcXqaYv/Romper_la_tabla.jpg" alt="Participante rompiendo su tabla en la Noche de Impacto" className="w-full h-auto object-cover" data-id="element-185" />
          </div>

          <div className="text-lg md:text-xl text-gray-300 space-y-4" data-id="element-186">
            <p data-id="element-187">Porque la mente no aprende leyendo.</p>
            <p className="font-bold text-white" data-id="element-188">La mente aprende haciendo.</p>
            <p data-id="element-189">
              Puedes leer 100 libros de autoayuda y seguir sintiéndote igual.
            </p>
            <p className="pt-4" data-id="element-190">
              Pero cuando tu cuerpo hace algo que creía imposible — algo físico,
              tangible, real — tu cerebro recibe una señal que no puede ignorar:
            </p>
            <p className="text-3xl md:text-4xl font-black text-[#F5A623] py-6" data-id="element-191">
              "Sí puedo."
            </p>
            <p data-id="element-192">Lo que escribiste en esa tabla ya no vive en ti.</p>
            <p className="font-bold text-white" data-id="element-193">Lo rompiste. Literalmente.</p>
            <p data-id="element-194">Esa impronta queda grabada.</p>
            <p className="pb-8" data-id="element-195">Y la llevas contigo.</p>
          </div>

          <CTAButton data-id="element-196">🔥 QUIERO VIVIR ESTA EXPERIENCIA — $5</CTAButton>
        </div>
      </div>
    </section>;
}